module.exports = __webpack_public_path__ + "static/img/Adam-Saad.3aa7e59.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Adam-Saad.jpg
// module id = o8sF
// module chunks = 0